import { baseColors } from "@Constants/baseStyles"
import { StyleSheet } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        paddingHorizontal: RFValue(25),
        paddingVertical: RFValue(10),
        borderRadius: RFValue(20),
        marginRight: 12,
        backgroundColor: baseColors.green.light
    }
})

export default styles
